module.exports = __webpack_public_path__ + "static/icons/icon-alert-b200e5819c5dc251643d0871fcf2d2a0.svg";